import { Anchor } from '@dnb/eufemia';
import { useParams } from 'react-router-dom';

import { useBackend } from '@/hooks/useBackend';
import useSWRExpect404 from '@/hooks/useSWRExpect404';

import { defaultError } from '../helpers';
import { ValidateSection } from './ValidateSection';
export function ValidateApiChampionSection() {
  const swrExpect404 = useSWRExpect404();
  const { teamId } = useParams();
  const { data: apiChampions } = useBackend(
    '/teams/{teamId}/members',
    teamId ? { params: { path: { teamId: teamId }, query: { apiChampion: true } } } : null,
    swrExpect404,
  );

  return (
    <ValidateSection
      additionalInformation={
        <p>
          See{' '}
          <Anchor href="https://dnb-asa.atlassian.net/wiki/spaces/KKO/pages/113050368/API+Champions+FAQ">
            API Champions FAQ
          </Anchor>{' '}
          for information on how to become an API Champion
        </p>
      }
      data={{
        apichampion: 'Have someone with the API champion role on the team',
      }}
      errorKey="apichampion"
      errors={{
        ...defaultError,
        apichampion:
          apiChampions?.length === 0
            ? {
                apichampion: 'To publish an API, at least one of your team members must be an API Champion.',
              }
            : null,
      }}
      noFormatSuffix
      title="API Champion"
    />
  );
}
